// ===========================================
// Which term and year a class note belongs to (the Notes modals' filters)
// ===========================================
// A note is filed by its SESSION day (`Note.date`, a @db.Date), compared as a `YYYY-MM-DD` key
// against the term's own day keys, both ends inclusive. The modals used to compare the note's
// `createdAt` INSTANT with the term's UTC-midnight dates, which in Sydney dropped a note written
// before ~10-11am on a term's first day or after it on the last, and filed a note written after
// the term ended under no term at all (#272 Phase 2 /qa M1: parents and students got terms for the
// first time, so this code went live).
//
// Deactivated terms (`isActive: false`, a soft delete) are not offered as filters.

interface DatedNote {
  date: string;
}

interface DatedTerm {
  startDate: string;
  endDate: string;
  isActive?: boolean;
}

const dayKey = (iso: string): string => iso.slice(0, 10);
const yearOfKey = (key: string): number => Number(key.slice(0, 4));

export const noteYear = (note: DatedNote): number => yearOfKey(dayKey(note.date));
export const termYear = (term: DatedTerm): number => yearOfKey(dayKey(term.startDate));

export function noteInTerm(note: DatedNote, term: DatedTerm): boolean {
  const key = dayKey(note.date);
  return key >= dayKey(term.startDate) && key <= dayKey(term.endDate);
}

/** The terms a Notes filter offers: deactivated ones are left out. */
export function filterableTerms<T extends DatedTerm>(terms: readonly T[]): T[] {
  return terms.filter((t) => t.isActive !== false);
}
